import type { AppLanguage } from '../../i18n';

export function getPublicSiteHomePath(language: AppLanguage | undefined) {
  return language === 'pl' ? '/pl/' : '/';
}

export function getPublicSiteGuidesPath(language: AppLanguage | undefined) {
  return language === 'pl' ? '/pl/baza-wiedzy/' : '/learn/';
}

export function getPublicSiteLegalLinks(language: AppLanguage | undefined) {
  if (language === 'pl') {
    return {
      privacy: '/pl/polityka-prywatnosci/',
      terms: '/pl/regulamin/',
      trainerDpa: '/pl/umowa-powierzenia-przetwarzania-danych/',
    } as const;
  }

  return {
    privacy: '/privacy/',
    terms: '/terms/',
    trainerDpa: '/trainer-dpa/',
  } as const;
}
